/**
 * 订单管理 数据列表
 */
<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>电表数据</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="page" class="user-search">
			<el-form-item label="搜索：">
			</el-form-item>
			<el-form-item>
				<el-date-picker v-model="date.date" align="right" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :picker-options="date.pickerOptions"></el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
			</el-form-item>
		</el-form>
		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column align="center" type="index" width="60"></el-table-column>
			<el-table-column sortable prop="date" label="时间" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="ZGL1" label="一号电表总有用功功率" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="A1" label="一号泵A项电流" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="C1" label="一号泵C项电流" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="ZGL2" label="二号电表总有用功功率" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="A2" label="二号泵A项电流" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="C2" label="二号泵C项电流" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="ZGL3" label="三号电表总有用功功率" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="A3" label="三号泵A项电流" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="C3" label="三号泵C项电流" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="ZGL4" label="四号电表总有用功功率" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="A4" label="四号泵A项电流" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="C4" label="四号泵C项电流" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="ZGL5" label="五号电表总有用功功率" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="A5" label="五号泵A项电流" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="C5" label="五号泵C项电流" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="ZGL6" label="六号电表总有用功功率" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="A6" label="六号泵A项电流" show-overflow-tooltip></el-table-column>
			<el-table-column sortable prop="C6" label="六号泵C项电流" show-overflow-tooltip></el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->

	</div>
</template>

<script>
import { esList } from '../../api/payMG';
import Pagination from '../../components/Pagination';
import { floatMultiply, timestampToTime } from '../../utils/util';
export default {
	data() {
		return {
			downloadDate: '',
			centerDialogVisible: false,
			//时间组件参数
			date: {
				pickerRangeOptions: {
					shortcuts: [
						{
							text: '最近一周',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(
									start.getTime() - 3600 * 1000 * 24 * 7
								);
								picker.$emit('pick', [start, end]);
							},
						},
						{
							text: '最近一个月',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(
									start.getTime() - 3600 * 1000 * 24 * 30
								);
								picker.$emit('pick', [start, end]);
							},
						},
						{
							text: '最近三个月',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(
									start.getTime() - 3600 * 1000 * 24 * 90
								);
								picker.$emit('pick', [start, end]);
							},
						},
					],
				},
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					shortcuts: [
						{
							text: '今天',
							onClick(picker) {
								picker.$emit('pick', new Date());
							},
						},
						{
							text: '昨天',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24);
								picker.$emit('pick', date);
							},
						},
						{
							text: '一周前',
							onClick(picker) {
								const date = new Date();
								date.setTime(
									date.getTime() - 3600 * 1000 * 24 * 7
								);
								picker.$emit('pick', date);
							},
						},
					],
				},
				date: new Date(),
			},
			//表单查询加载
			loading: false,
			//手动查询参数
			page: {
				page: {
					current: 1,
					size: 24,
				},
				mn: '',
				startDate: '',
				endDate: '',
			},
			userparm: [], //搜索权限
			listData: [], //查询结果数据
			companyList: [],
			resultLength: 0,
			// 分页组件默认参数
			pageparm: {
				pageIndex: [24, 60],
				currentPage: 1,
				pageSize: 24, //每页显示条数
				total: 10, //
			},
		};
	},
	// 注册组件
	components: {
		Pagination,
	},
	/**
	 * 创建完毕
	 */
	created() {
	},
	watch: {
		'date.date'(newVal, oldVal) {
			this.page.startDate = newVal + ' 00:00:00';
			this.page.endDate = newVal + ' 23:59:59';
		},
	},

	/**
	 * 里面的方法只有被调用才会执行
	 */
	methods: {
		getdata(parameter) {
			this.loading = true;

			/***
			 * 调用接口，注释上面模拟数据 取消下面注释
			 */
			parameter.type="1"
			 esList(parameter)
				.then((res) => {
					this.loading = false;
					this.listData = res.data.list;
					// this.resultLength = res.data.total;
					// 分页赋值
					// this.pageparm.currentPage = res.data.current;
					// this.pageparm.pageSize = res.data.size;
					// this.pageparm.total = res.data.total;
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error('菜单加载失败，请稍后再试！');
				});
		},
		// 分页插件事件
		callFather(parm) {
			this.page.page.current = parm.currentPage;
			this.page.page.size = parm.pageSize;
			this.getdata(this.page);
		},
		// 搜索事件
		search() {
			this.getdata(this.page);
		},
	},
};
</script>

<style scoped>
.user-search {
	margin-top: 20px;
}
.userRole {
	width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/PowerData.vue